angular
    .module('empower.uploadDocument')
    .constant('documentUploadTypeConst', {
        EMPLOYER: [
            'Medical Certificate',
            'Reimbursement',
            'Travel',
            'Policy/Premium',
            'Weekly Benefits',
            'Other'
        ],
        WORKER: [
            'Medical Certificate',
            'Reimbursement',
            'Travel',
            'Weekly Benefits',
            'Other'
        ],
        NSI_EMPLOYER: [
            'Medical Certificate',
            'Reimbursement',
            'Travel',
            'Weekly Benefits',
            'Other'
        ]
    });